module.exports = __webpack_public_path__ + "static/img/20210113165805.283b0f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20210113165805.jpg
// module id = K7ct
// module chunks = 2